import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import type { ResourceTableSortOption } from '@ctw/shared/content/resource/resource-table-actions';

export const defaultRiskSort: ResourceTableSortOption<RiskGapModel> = {
  display: 'Status & type',
  sorts: [
    { key: 'statusSortRank', dir: 'asc' },
    { key: 'typeSortRank', dir: 'asc' },
    { key: 'title', dir: 'asc' }, // To guarantee stable sort
  ],
};

// Note: Sort options are only available for the legacy risk gap page.
export const riskSortOptions: Array<ResourceTableSortOption<RiskGapModel>> = [
  defaultRiskSort,
  {
    display: 'Name (A to Z)',
    sorts: [{ key: 'title', dir: 'asc' }],
  },
  {
    display: 'Name (Z to A)',
    sorts: [{ key: 'title', dir: 'desc' }],
  },
];
